(function() {
    'use strict';

    angular
    .module('itxApp.legacy')
    .service('SfiReturnsService', SfiReturnsService);

    SfiReturnsService.$inject = [
        '$q',
        'CountryService',
        'ItxTranslateSvc',
        'DUTTI_CONS'
    ];

    function SfiReturnsService (
        $q,
        CountryService,
        ItxTranslateSvc,
        DUTTI_CONS
    ) {
        var _this = this;
        
        _this.sfiReturnObject={};

        _this.returnData={};

        _this.isGuest = false;
        _this.guestToken = 
        _this.sfiPage = 'ItxSfiReturnsPage';

        _checkConditions();

        var service =  {
            getOrder: getOrder,
            isSfi: isSfi,
            getReturnDetails: getReturnDetails,
            sendReturnRequest: sendReturnRequest,
            getSfiObject: getSfiObject,
            setSfiObject: setSfiObject,
            getRmaReq: getRmaReq,
            getInitialModel: getInitialModel,
            getAccountTypes: getAccountTypes,
            sendRefundRequest: sendRefundRequest,
            getBankList: getBankList
        };

        return service;

        /**
        * @ngdoc method
        * @name isSfi
        * @methodOf returns.service:SfiReturnsService
        * @description
        * Returns if the given order has the `sfiCreditEnabled` true.
        * @param {object} order Order object 
        * @returns {boolean} returns if the order is SFI.
        */
        function isSfi(order){
            if(CountryService.is(DUTTI_CONS.country.CN)){
                return false;
            }
            return order.sfiCreditEnabled;
        }
        /**
        * @ngdoc method
        * @name getOrder
        * @methodOf returns.service:SfiReturnsService
        * @description
        * Get order object
        */
        function getOrder(orderId){
            var deferred = $q.defer();
            
            joyr.rest.xRestGetOrder(orderId)
            .done(function(order){
                deferred.resolve(order);
            })
            .Catch(function(error){
                deferred.reject(error);
            });
            
            return deferred.promise;
        }
        /**
        * @ngdoc method
        * @name getReturnDetails
        * @methodOf returns.service:SfiReturnsService
        * @description
        * Get the return detail information with the given rmaId.
        * 
        * @param {number} rmaId return unique identifier
        * @param {string} guestToken Guest Token if applies.
        */
        function getReturnDetails(){
            var params = inditex.iParams;

            var deferred = $q.defer();
            if(params.rmaReqId){
                getRmaReq(params.rmaReqId[0]);
            }
            var action = {
                action: 'order:rma',
                params: {
                    storeId: inditex.iStoreId,
                    rmaId: params.rmaId[0]
                }
            };

            if(_this.isGuest && params.guestToken){
                action.params.tokenGuest=params.guestToken[0];
                _this.guestToken = action.params.tokenGuest;
            }

            joyr.rest.xRestExecute([action])
            .done(function (data) {
                _this.returnData= data[0];
                
                if(!_this.returnData || !_this.returnData.orderId) {
                    deferred.reject('order id missed');
                }

                getOrder(_this.returnData.orderId)
                .then(function(order){
                    data[0].items = order;
                    deferred.resolve(data[0]);
                })
                .catch(function(error){
                    deferred.reject(error);
                });
            })
            .Catch(function(error){
                deferred.reject(error);
            });
                                
            return deferred.promise;
        }
        /**
        * @ngdoc method
        * @name sendReturnRequest
        * @methodOf returns.service:SfiReturnsService
        * @description
        * Send the return request to the API.
        * 
        * @param {object} sfiReturnObject Object with return information
        */
        function sendReturnRequest(sfiReturnObject,returnObject){
            var deferred = $q.defer();
            var action = {
                action: 'order:returnRequest',
                params: {
                    storeId: inditex.iStoreId,
                    orderId: _this.returnData.orderId
                }
            };
            
            if(_this.isGuest && _this.guestToken){
                action.params.tokenGuest=_this.guestToken;
            }

            // If i am in my account and I have address, return lines, etc.
            action.data = (returnObject)? returnObject : _getDefaultReturnObject();
            
            action.data.cashReturnForm = {
                associatedPaymentMethod: sfiReturnObject.associatedPaymentMethod,
                firstName: sfiReturnObject.firstName,
                lastName: sfiReturnObject.lastName,
                documentNumber: sfiReturnObject.documentNumber,
                returnMethodForm: {
                    accountNumber: sfiReturnObject.iban,
                    bankName: sfiReturnObject.bankName,
                    bicCode: sfiReturnObject.bic,
                    cardNumber: sfiReturnObject.cardNumber,
                }
            };

            joyr.rest.xRestExecute([action])
            .done(function (data) {
                deferred.resolve(data[0]);
            })
            .Catch(function(){
                deferred.reject();
            });
                
            return deferred.promise;
        }

        function sendRefundRequest(refundObject, orderId){
            var deferred = $q.defer();

            var action = {
                action: 'ADD_ORDER_REFUND',
                params: {
                    storeId: inditex.iStoreId,
                    orderId: orderId
                }
            };

            action.data = {
                contactDetail: {
                    email: inditex.iUserJSON.email
                },
                bankAccount: {
                    firstName: refundObject.firstName,
                    lastName: refundObject.lastName,
                    bankName: refundObject.bankName,
                    accountCode: refundObject.iban
                }
            };

            if(refundObject.accountType && refundObject.accountType.accountTypeCode){
                action.data.bankAccount.accountType = refundObject.accountType.accountTypeCode;
            }
            if(refundObject.vatin){
                action.data.bankAccount.nif = refundObject.vatin;
            }
            if(refundObject.documentTypeData && refundObject.documentTypeData.type){
                action.data.bankAccount.documentTypeCode = refundObject.documentTypeData.type
            }
            if(refundObject.bic){
                action.data.bankAccount.bicCode = refundObject.bic
            }
            if (refundObject.documentNumber) {
                action.data.bankAccount.nif = refundObject.documentNumber;
            }
            if (refundObject.cardNumber) {
                action.data.bankAccount.pan = refundObject.cardNumber;
            }

            joyr.rest.xRestExecute([action])
            .done(function (data) {
                deferred.resolve(data);
            })
            .Catch(function(error){
                deferred.reject(error);
            });

            return deferred.promise;
        }

        /**
        * @ngdoc method
        * @name _getDefaultReturnObject
        * @methodOf returns.service:SfiReturnsService
        * @description
        * When we not have the user address information, the return lines and reasons, number of boxes, etc. 
        * because the return was initiated in the store, we need to send to the API a default address object, 
        * with only country code, a return line array with the catentry and the quantity get from the RMA request and
        * a default number of boxes to 1. The param `isStoreReturn` must be 1 (true).
        * 
        * @returns {object} Object with address, returnlines, returnReason, numboxes and isStoreReturn information.
        * 
        * @example
        * <pre>
        *   {
        *       address: {
        *           'countryCode': 'PT',
        *       },
        *       returnLines: [ {
        *           catentryId: 12346789,
        *           comment:'',
        *           quantity: 1,
        *           returnReasonId: 2
        *        }],
        *       returnReason: '-',
        *       numBoxes: 1,
        *       isStoreReturn: 1
        *   }
        * </pre>
        */
        function _getDefaultReturnObject(){
            var obj={
                address: {
                    'countryCode': inditex.iCountryCode,
                },
                returnLines: [ {
                    catentryId: _this.returnData.rmaitems[0].catentryId,
                    comment:'',
                    quantity: _this.returnData.rmaitems[0].quantity,
                    returnReasonId: 2
                 }],
                returnReason: '-',
                numBoxes: 1,
                isStoreReturn: 1
            };

            return obj;
        }
        /**
        * @ngdoc method
        * @name setSfiObject
        * @methodOf returns.service:SfiReturnsService
        * @description
        * Fill the SFI object with the given object
        * @param {object} obj Object with Sfi form information
        * @example
        * <pre>
        * {
        *     associatedPaymentMethod: 4, // Always 4.
        *     firstName: "John",
        *     lastName: "Doe",
        *     returnMethodForm: {
        *         accountNumber: "ES7921000813610123456789",
        *         bicCode: "BBVAESMM813",
        *         bankName: "BEST BANK"
        *     }
        * }
        * </pre>
        */
        function setSfiObject (obj){
            _this.sfiReturnObject = {
                associatedPaymentMethod: inditex.iStoreJSON.details.enableSfi ? 4 : 1,
                firstName: obj.firstName,
                lastName: obj.lastName,
                documentNumber: obj.documentNumber,
                returnMethodForm: {
                    accountNumber: obj.iban,
                    bicCode: obj.bic,
                    bankName: obj.bankName,
                    cardNumber: obj.cardNumber,
                }
            };

            if(inditex.iCountryCode === 'TN'){
                _this.sfiReturnObject.associatedPaymentMethod = 1;
            }

            if(inditex.iCountryCode === 'KZ'){
                _this.sfiReturnObject.associatedPaymentMethod = 1;
                _this.sfiReturnObject.documentType = obj.beneficiaryCode;
            }

            //India

            if(inditex.iCountryCode === 'IN'){
                _this.sfiReturnObject = {
                    associatedPaymentMethod: 1,
                    firstName: obj.firstName,
                    lastName: obj.lastName,
                    returnMethodForm: {
                        accountNumber:obj.iban,
                        innCode:obj.ifscCode,
                        bankAccountType: obj.accountType.accountTypeCode
                    }
                }
            }

            // Philipines

            if (inditex.iCountryCode === 'PH') {
                _this.sfiReturnObject = {
                    associatedPaymentMethod: 1,
                    firstName: obj.firstName,
                    lastName: obj.lastName,
                    returnMethodForm: {
                        accountNumber: obj.iban,
                        bankName: obj.bankName,
                        bankAccountType: obj.accountType.accountTypeCode
                    }
                };
            }

            if(inditex.iCountryCode === 'CO'){
                // 1 = Devolución transferencia bancaria
                _this.sfiReturnObject = {
                    associatedPaymentMethod: 1,
                    firstName: obj.firstName,
                    lastName: obj.lastName,
                    documentType: obj.documentTypeData.type,
                    documentNumber: obj.vatin,
                    returnMethodForm: {
                        accountNumber: obj.iban,
                        bicCode: obj.bic,
                        bankName: obj.bankName,
                        bankAccountType: obj.accountType.accountTypeCode
                    }
                };
            }

            if (inditex.iCountryCode === 'RS' || inditex.iCountryCode === 'BA') {
                // 1 = Devolución transferencia bancaria
                _this.sfiReturnObject = {
                    associatedPaymentMethod: 1,
                    firstName: obj.firstName,
                    lastName: obj.lastName,
                    returnMethodForm: {
                        accountNumber: obj.iban,
                        country: obj.country.countryCode,
                        city: obj.city,
                        address: obj.address,
                        zipCode: obj.zipCode
                    }
                };
            }

            if (inditex.iCountryCode === 'ID'){
                // 1 = Devolución transferencia bancaria
                _this.sfiReturnObject = {
                    associatedPaymentMethod: 1,
                    firstName: obj.firstName,
                    lastName: obj.lastName,
                    returnMethodForm: {
                        accountNumber: obj.iban,
                        bicCode: obj.bic
                    }
                };
            }

            if (inditex.iCountryCode === 'GE'){
                // 1 = Devolución transferencia bancaria
                _this.sfiReturnObject = {
                    associatedPaymentMethod: 1,
                    firstName: obj.firstName,
                    lastName: obj.lastName,
                    returnMethodForm: {
                        accountNumber: obj.iban,
                    }
                };
            }

            if (inditex.iCountryCode === 'MK'){
                // 1 = Devolución transferencia bancaria
                _this.sfiReturnObject = {
                    associatedPaymentMethod: 1,
                    firstName: obj.firstName,
                    lastName: obj.lastName,
                    returnMethodForm: {
                        accountNumber: obj.iban,
                        country: obj.country.countryCode,
                        city: obj.city,
                        address: obj.address,
                        zipCode: obj.zipCode
                    }
                };
            }
        }
        /**
        * @ngdoc method
        * @name getRmaReq
        * @methodOf returns.service:SfiReturnsService
        * @description
        * Get the return request information.
        * 
        * @param {number} rmareqId Return request number
        * @param {string} guestToken Guest Token if applies.
        */
        function getRmaReq (rmareqId, guestToken){

            var deferred = $q.defer();
            var action = {
                action: 'rma:requestInfo',
                params: {
                    storeId: inditex.iStoreId,
                    rmareqId: rmareqId
                }
            };

            if(guestToken){
                action.action='rma:requestInfoGuest';
                action.params.tokenGuest=guestToken;
            }
           
            joyr.rest.xRestExecute([action])
            .done(function (data) {
                deferred.resolve(data[0]);
            })
            .Catch(function(){
                deferred.reject();
            });
                
            return deferred.promise;
        }
        /**
        * @ngdoc method
        * @name getSfiObject
        * @methodOf returns.service:SfiReturnsService
        * @description
        * Return Sfi Return Object
        */
        function getSfiObject(){
            return _this.sfiReturnObject;
        }


        /**
        * @ngdoc method
        * @name getInitialModel
        * @methodOf returns.service:SfiReturnsService
        * @description
        * Returns the initial object structure for current country.
        */
        function getInitialModel(orderPayment = {}){
            _this.model = {
                country: {
                    countryName: inditex.iCountryName,
                    countryCode: inditex.iCountryCode
                },
                firstName: '',
                lastName: '',
                iban:'',
                bic:''
            };

            if (CountryService.is(DUTTI_CONS.country.SA)) {
                _this.model.country = undefined;
                _this.model.bankName =  '';
                _this.model.bic = undefined;
            } else if (CountryService.is(DUTTI_CONS.country.CO)) {
                _this.model.bankName = '';
                _this.model.accountType = {};
                _this.model.documentType = {};
                _this.model.documentNumber = undefined;
                _this.model.country = undefined;
                _this.model.bic = undefined;
            } else if (CountryService.is(DUTTI_CONS.country.UA) && orderPayment.kind.toUpperCase() === joyr.constants.paymentMethods.COD){
                _this.model.documentNumber = '';
                _this.model.cardNumber = '';
                _this.model.country = undefined;
                _this.model.bic = undefined;
            } else if (CountryService.is(DUTTI_CONS.country.KZ) && orderPayment.kind.toUpperCase() === joyr.constants.paymentMethods.COD){
                _this.model.documentNumber = '';
                _this.model.bankName = '';
                _this.model.bankList = '';
                _this.model.beneficiaryCode = '';
                _this.model.documentType = {};
                _this.model.country = undefined;
            } else if (CountryService.is(DUTTI_CONS.country.RS) && orderPayment.kind.toUpperCase() === joyr.constants.paymentMethods.COD) {
                _this.model.documentType = {};
            } else if (CountryService.is(DUTTI_CONS.country.MK) && orderPayment.kind.toUpperCase() === joyr.constants.paymentMethods.COD){
                _this.model.bic = undefined;
            } else if (CountryService.is(DUTTI_CONS.country.IN)){
                _this.model.accountType = {};
                _this.model.documentNumber = undefined;
                _this.model.ifscCode = '';
                _this.model.bankName = undefined;
                _this.model.country = undefined;
                _this.model.bic = undefined;
            }
            // TODO: India

            return _this.model;
        }

        /**
        * @ngdoc method
        * @name _checkConditions
        * @private
        * @methodOf returns.service:SfiReturnsService
        * @description
        * If user is logged in and the rmaId parameter doesn't exists redirect to the home page.
        * If user is not logged in and the param guestToken doesn't exists then
        * redirect to the authentication page in order to require the user to be logged in.
        */
        function _checkConditions(){

            if(_this.sfiPage!=inditex.iPage){
                return;
            }

            if(_this.isGuest && !inditex.iParams.guestToken) {
                var params = {
                    loginOnly: true, 
                    redirect: window.location.href
                };
                NavigationService.goToAuthPage(params);
            }

            if(!_this.isGuest && !inditex.iParams.rmaId && !inditex.iParams.rmaReqId){
                NavigationService.goToHomePage();
            }
        }

        /**
         * get Colombia account types values
         */
        function  getAccountTypes() {
            var accountTypes = [
                {
                    name: ItxTranslateSvc.translateCms('legacy.dev.forms.accountType.items.savings'),
                    value: '1'
                },
                {
                    name: ItxTranslateSvc.translateCms('legacy.dev.forms.accountType.items.current'),
                    value: '2'
                }
            ];
            return accountTypes;
        };

        /**
        * get Indonesia Bank List
        */
        function getBankList() {
            const list = [
                {
                    order: 1,
                    name: 'BRI',
                    registered: 'PT Bank Rakyat Indonesia (Persero) Tbk',
                    code: 'BRINIDJA',
                    accountNumberDigits: 15
                },
                {
                    order: 2,
                    name: 'Mandiri Bank',
                    registered: 'PT Bank Mandiri (Persero) Tbk',
                    code: 'BMRIIDJA',
                    accountNumberDigits: 13
                },
                {
                    order: 3,
                    name: 'BCA',
                    registered: 'PT Bank Central Asia Tbk',
                    code: 'CENAIDJA',
                    accountNumberDigits: 10
                },
                {
                    order: 4,
                    name: 'BNI',
                    registered: 'PT Bank Negara Indonesia (Persero) Tbk',
                    code: 'BNINIDJA',
                    accountNumberDigits: 10
                },
                {
                    order: 5,
                    name: 'BTN',
                    registered: 'PT Bank Tabungan Negara (Persero) Tbk',
                    code: 'BTANIDJA',
                    accountNumberDigits: 16
                },
                {
                    order: 6,
                    name: 'CIMB Niaga',
                    registered: 'PT Bank CIMB Niaga Tbk',
                    code: 'BNIAIDJA',
                    accountNumberDigits: 12
                },
                {
                    order: 7,
                    name: 'Bank ANZ',
                    registered: 'PT Bank ANZ Indonesia',
                    code: 'ANZBIDJX',
                    accountNumberDigits: 13
                },
                {
                    order: 8,
                    name: 'OCBC NISP',
                    registered: 'Bank OCBC NISP	NISPIDJA',
                    code: 'NISPIDJA',
                    accountNumberDigits: 12
                },
                {
                    order: 9,
                    name: 'Bank Maybank Indonesia',
                    registered: 'PT Bank Maybank Indonesia',
                    code: 'IBBKIDJA',
                    accountNumberDigits: 10
                },
                {
                    order: 10,
                    name: 'Bank Danamon',
                    registered: 'PT Bank Danamon Indonesia Tbk',
                    code: 'BDINIDJA',
                    accountNumberDigits: 10
                }
            ];
            return list;
        }
    }

})();